import { NgClass } from '@angular/common';
import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
	ViewChildren,
} from '@angular/core';
import { FormControl } from '@angular/forms';

import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { BaseDirective } from '@valk-nx/core/lib/directives/base/base.directive';

import { RadioOptions } from './radio.interface';

@Component({
	exportAs: 'vpRadio',
	selector: 'vp-radio-group',
	imports: [NgClass, TranslatePipe],
	templateUrl: './radio-group.html',
})
export class RadioGroupComponent extends BaseDirective implements OnChanges {
	@Input() options: RadioOptions[] = [];
	@Input() horizontal = false;
	@Input() name = '';
	@Input() readonly = false;
	@Input() disabled = false;
	@Input() hasError = false;
	@Input() isValid = false;
	@Input() shouldTranslate = false;
	@Input() customFormControl = new FormControl();

	@Output() radioGroupValue = new EventEmitter<string>();

	@ViewChildren('radioInput') radioInputs: ElementRef[] = [];

	selectedOption = '';

	constructor(
		override readonly translate: TranslateService,
		readonly cd: ChangeDetectorRef,
	) {
		super(translate);
	}

	ngOnChanges(changes: SimpleChanges) {
		// NOTE: Reset the nativeElement when the firstChange is false and the currentValue is false
		if (
			changes['isValid'] &&
			!changes['isValid'].firstChange &&
			!changes['isValid'].currentValue
		) {
			// NOTE: bind options again because somehow the selected option is not reset in the HTML
			this.options = [...this.options];

			this.radioInputs.forEach((input) => {
				input.nativeElement.checked = false;
			});
			this.cd.detectChanges();
		}
	}

	radioChangedValue(id: string): void {
		this.selectedOption = id;

		this.radioGroupValue.emit(this.selectedOption);
		this.customFormControl.setValue(this.selectedOption);
	}
}
